// Bootstrap script is dinamically imported so eager consumption of
// certain modules (e.g. React) will not throw an error
import('./bootstrap');
export {};
